import { useDraggable } from "@dnd-kit/core";
import { Lock } from "lucide-react";
import type { KanbanCard as KanbanCardType } from "../../../services/whatsapp/whatsappService";

interface KanbanCardProps {
  card: KanbanCardType;
}

const KanbanCardComponent = ({ card }: KanbanCardProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging,
  } = useDraggable({ id: card.id, disabled: card.ai_enabled });

  const style = transform
    ? { transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`, zIndex: 50 }
    : undefined;

  const total = typeof card.total === "number"
    ? `$${card.total.toLocaleString()}`
    : `$${card.total}`;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`bg-white rounded-lg p-3 shadow-sm border border-gray-100 mb-2 select-none ${
        card.ai_enabled ? "cursor-not-allowed opacity-70" : "cursor-grab active:cursor-grabbing"
      } ${isDragging ? "shadow-lg ring-2 ring-blue-200 opacity-90" : ""}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="text-xs font-semibold text-gray-900">#{card.order_id}</span>
            {card.ai_enabled && <Lock className="w-3 h-3 text-gray-400" />}
          </div>
          {card.customer_name && (
            <p className="text-xs text-gray-500 truncate mt-0.5">{card.customer_name}</p>
          )}
          {card.product_name && (
            <p className="text-xs text-gray-400 truncate mt-0.5">{card.product_name}</p>
          )}
          <p className="text-xs font-medium text-gray-700 mt-1">{total}</p>
        </div>
      </div>
      {card.created_at && (
        <p className="text-[10px] text-gray-400 mt-2">
          {new Date(card.created_at).toLocaleDateString([], { day: "2-digit", month: "short" })}
        </p>
      )}
    </div>
  );
};

export default KanbanCardComponent;
